export default {
  path: "/moduleMain",
  meta: {
    title: "公用路由"
  },
  component: () => import("../views/moduleMain.vue"),
  children: [
    // 单页
    {
      path: "/info/:menuId",
      meta: {
        title: "单页-文章",
        contentType: "c-1",
        sortType: "s-1"
      },
      component: () => import("../views/public/info.vue")
    },
    {
      path: "/info_content/:menuId",
      meta: {
        title: "单页-富文本",
        contentType: "c-1",
        sortType: "s-4"
      },
      component: () => import("../views/public/infoContent.vue")
    },
    {
      path: "/info_content_banner/:menuId",
      meta: {
        title: "单页-富文本有Banner",
        contentType: "c-1",
        sortType: "s-13"
      },
      component: () => import("../views/public/infoContentBanner.vue")
    },
    // 图文列表
    {
      path: "/time_axis_portrait_list/:menuId",
      meta: {
        title: "图文列表-时间轴",
        contentType: "c-2",
        sortType: "s-2"
      },
      component: () => import("../views/public/timeAxisPortraitList.vue")
    },
    {
      path: "/image_list_3n/:menuId",
      meta: {
        title: "图文列表-普通-3个",
        contentType: "c-2",
        sortType: "s-3"
      },
      component: () => import("../views/public/imageList_3n.vue")
    },
    {
      path: "/image_list_new3n/:menuId",
      meta: {
        title: "图文列表-新闻有详情-3个",
        contentType: "c-2",
        sortType: "s-10"
      },
      component: () => import("../views/public/imageList_new3n.vue")
    },
    {
      path: "/image_list_new1n/:menuId",
      meta: {
        title: "图文列表-新闻有详情-1个",
        contentType: "c-2",
        sortType: "s-11"
      },
      component: () => import("../views/public/imageList_new1n.vue")
    },
    {
      path: "/image_list_4n/:menuId",
      meta: {
        title: "图文列表-普通有详情-4个",
        contentType: "c-2",
        sortType: "s-8"
      },
      component: () => import("../views/public/imageList_4n.vue")
    },
    {
      path: "/image_list_s4n/:menuId",
      meta: {
        title: "图文列表-简单有详情-4个",
        contentType: "c-2",
        sortType: "s-9"
      },
      component: () => import("../views/public/imageList_s4n.vue")
    },
    {
      path: "/image_banner/:menuId",
      meta: {
        title: "图文列表-轮播图",
        contentType: "c-2",
        sortType: "s-5"
      },
      component: () => import("../views/public/imageList_banner.vue")
    },
    {
      path: "/image_personnel_info/:menuId",
      meta: {
        title: "图文列表-人员信息",
        contentType: "c-2",
        sortType: "s-6"
      },
      component: () => import("../views/public/imagePersonnelInfo.vue")
    },
    {
      path: "/image_ver_alt_list/:menuId",
      meta: {
        title: "图文列表-图片文字纵向交替列表",
        contentType: "c-2",
        sortType: "s-7"
      },
      component: () => import("../views/public/imageVerAltList.vue")
    },
    // 文字列表
    {
      path: "/word_card/:menuId",
      meta: {
        title: "文字列表-名片有Banner",
        contentType: "c-3",
        sortType: "s-12"
      },
      component: () => import("../views/public/wordCard.vue")
    },
    // 菜单新

    //模板6
    {
      path: "/word_list6",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList6.vue")
    },
    {
      path: "/word_list2",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList2.vue")
    },
    {
      path: "/word_list1/:menuId",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList1.vue")
    },
    {
      path: "/word_list3/:menuId",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList3.vue")
    },
    {
      path: "/word_list7/:menuId",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList7.vue")
    },
    {
      path: "/word_list13/:menuId",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList13.vue")
    },
    {
      path: "/word_list14/:menuId",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList14.vue")
    },
    {
      path: "/word_list16/:menuId",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList16.vue")
    },
    {
      path: "/word_list20/:menuId",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList20.vue")
    },
    {
      path: "/word_list4",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList4.vue")
    },
    {
      path: "/word_list5",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList5.vue")
    },
    {
      path: "/word_list8",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList8.vue")
    },
    {
      path: "/word_list12",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList12.vue")
    },
    {
      path: "/word_list11",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList11.vue")
    },
    {
      path: "/word_list15",
      meta: {
        title: "文字列表"
      },
      component: () => import("../views/public/wordList15.vue")
    },
    {
      path: "/article_details/:menuId",
      meta: {
        title: "文章详情",
        keepAlive: false
      },
      component: () => import("../views/public/wordDetail.vue")
    }
  ]
};
